export default "__VITE_ASSET__D0W9eT6I__"